import Lenis from 'lenis';
import { gsap, ScrollTrigger } from './gsap';

let instance: Lenis | null = null;

export const prefersReducedMotion = (): boolean =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export function initLenis(): Lenis | null {
  if (instance) return instance;
  if (prefersReducedMotion()) return null;

  instance = new Lenis({
    lerp: 0.09,
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 1.2,
  });

  instance.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time: number) => {
    instance?.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);

  document.body.classList.add('is-lenis-ready');

  return instance;
}

export function getLenis(): Lenis | null {
  return instance;
}

export function scrollToEl(el: HTMLElement, offset = 0): void {
  if (instance) {
    instance.scrollTo(el, { offset, duration: 1.1 });
  } else {
    const top = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }
}
